import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
export default {
    name: "DataSIgnalSiteSummaryPopup",
    props: {
        data: {
            type: Array,
            required: true,
            default: () => []
        },
        heading: String,
    },
    components: {
        customModal
    },
    data() {
        return {
            head: {},
            idToken: "",
            baseUrl: process.env.VUE_APP_Service_URL,
            studyId: "",
            defaultdate: "",
            selectedFlagType: ""
        };
    },
    computed: {
        flattenedData() {
            return this.data.flatMap(site =>
                site.criticalDataSignal.map(signal => ({
                    siteCode: site.siteCode,
                    runDate: site.runDate,
                    flagType: signal.flagType,
                    fieldNames: signal.flagTypes
                        .flatMap(ft => ft.fieldName)
                        .join(", "),
                }))
            );
        },
    },

    async mounted() {
        console.log("data in site summary popup", this.data);
        this.idToken = store.getters.getIdToken;
        this.defaultdate = localStorage.getItem("dateformat");
    },
    methods: {
        closeModal() {
            this.$emit("closeCriticalSites");
        },
        filter(date) {
            if (date) {
                return moment(date).format(this.defaultdate)
            }
        },
        description(flagType) {
            const descriptions = {
                "Digit preference":
                    "Digit preference refers to the tendency of certain digits to appear more frequently than others in a dataset, often due to human bias or measurement errors.",

                "Exact repetition":
                    "Exact repetition occurs when identical values are repeated in a dataset, which can indicate issues such as data entry errors or lack of diversity in the sample.",

                "Extreme digit preference":
                    "Extreme digit preference is a more pronounced form of digit preference, where certain digits are significantly overrepresented in the data.",

                "Zero variability":
                    "Zero variability occurs when a dataset contains no variation in values.",

                "Low variability":
                    "Low variability refers to a dataset that has very little variation in its values."
            };

            return descriptions[flagType] || "No description available.";
        }
    }

};